import {
  DOCIA_GERMAN_SPEAKING_LEVELS,
  GERMAN_SPEAKING_LEVEL_I18N,
  GermanSpeakingLevel,
  NON_DOCIA_GERMAN_SPEAKING_LEVELS,
} from '@pflegia/types/common/candidate/german-speaking-level';

export {
  /** @deprecated Import from @pflegia/types/common instead. */
  DOCIA_GERMAN_SPEAKING_LEVELS,
  /** @deprecated Import from @pflegia/types/common instead. */
  GERMAN_SPEAKING_LEVEL_I18N,
  /** @deprecated Import from @pflegia/types/common instead. */
  GermanSpeakingLevel,
  /** @deprecated Import from @pflegia/types/common instead. */
  NON_DOCIA_GERMAN_SPEAKING_LEVELS,
};
